import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=28b685a0"
import script from "./Templates.ts?vue&type=script&lang=ts&external"
export * from "./Templates.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports